// eslint-disable-next-line
__webpack_public_path__ = window.__webpack_public_path__;
